import styled from 'styled-components'
import icoDown from '../../assets/icons/down.svg'

function Select({options, selected, setValue, placeholder, error, disabledOptions, defaultValue}) {
    const onSelect = event => {
        setValue(event.target.value)
    }

    const getSelectedValue = () => {
        return options.find(element => element.key === selected)?.value || null
    }

    return (
        <Wrapper selected={selected} error={error}>
            <div>
                {selected ? getSelectedValue() : placeholder}
            </div>
            <img src={icoDown} alt=''/>
            <select onChange={onSelect} defaultValue={defaultValue}>
                {options.map(option =>
                    <option key={option.key} disabled={disabledOptions && disabledOptions.includes(option.value)} value={option.key}>
                        {option.value}
                    </option>
                )}
            </select>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    background-color: #f4f4f452;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 10px;
    padding: 10px;
    position: relative;
    text-align: left;
    font-size: 15px;
    color: ${props => props.selected ? '#000000' : '#00000078'};

    ${props => props.error && `
        color: red;
        border-color: red;
    `}

    img {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
    }

    select {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
`;


export default Select;
